import { useState } from "react";
import { Bookmark, BookmarkCheck, Copy, Loader2, Wand2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { Markdown } from "@/components/Bits";
import { suggestFolder } from "@/components/SaveToPlaybook";

export const FillTemplate = ({ item }) => {
  const [busy, setBusy] = useState(false);
  const [text, setText] = useState("");
  const [fillId, setFillId] = useState(null);
  const [saved, setSaved] = useState(null);
  if (!item.content?.trim() || item.type === "video") return null;
  const save = async () => {
    setSaved("saving");
    try { const r = await api.post("/playbook/template", { fill_id: fillId }); setSaved(fillId); suggestFolder(r.data); } catch (e) { setSaved(null); toast.error(errMsg(e)); }
  };
  const fill = async () => {
    setBusy(true);
    try { const r = await api.post(`/me/templates/${item.id}/fill`); setText(r.data.text); setFillId(r.data.fill_id); setSaved(null); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const copy = () => navigator.clipboard.writeText(text).then(() => toast.success("Copied to clipboard"));
  return (
    <div className="space-y-3" data-testid="fill-template">
      <div className="flex flex-wrap items-center gap-2">
        <Button type="button" variant="outline" onClick={fill} disabled={busy} data-testid="fill-template-btn" className="rounded-full border-pinkb/50 text-navy">
          {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Wand2 className="h-4 w-4 mr-2 text-pinkb" />}{busy ? "Filling it in…" : text ? "Fill again" : "Fill with my details"}
        </Button>
        <span className="text-xs text-muted-foreground">Uses your Roots Profile. Free, doesn't use your questions.</span>
      </div>
      {text && (
        <div className="rounded-xl border-2 border-dashed border-pinkb/30 bg-pinkb/5 p-5 fade-up">
          <div className="text-xs font-mono uppercase text-pinkb mb-2">Your version · check anything in [brackets]</div>
          <Markdown testId="fill-template-result">{text}</Markdown>
          <Button type="button" size="sm" onClick={copy} data-testid="fill-template-copy" className="mt-3 rounded-full bg-navy hover:bg-navy/90 text-white"><Copy className="h-3.5 w-3.5 mr-1.5" />Copy my version</Button>
          <Button type="button" size="sm" variant="outline" onClick={save} disabled={!!saved} data-testid="fill-template-save" className={`mt-3 ml-2 rounded-full ${saved === fillId ? "text-pinkb border-pinkb/50" : ""}`}>
            {saved === fillId ? <BookmarkCheck className="h-3.5 w-3.5 mr-1.5" /> : saved ? <Loader2 className="h-3.5 w-3.5 mr-1.5 animate-spin" /> : <Bookmark className="h-3.5 w-3.5 mr-1.5" />}{saved === fillId ? "Saved to playbook" : "Save to playbook"}
          </Button>
        </div>
      )}
    </div>
  );
};
